/**
 * Validates if a string is a valid HTTP/HTTPS URL
 * @param urlString - The URL string to validate
 * @returns true if the URL is valid (or empty), false otherwise
 */
export const isValidUrl = (urlString: string): boolean => {
  if (!urlString.trim()) return true;
  try {
    const url = new URL(urlString.trim());
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

